import styled from '@emotion/styled';

import Box from '~/common/components/Box';
import Text from '~/common/components/Texts/Text';
import UnderwriterCheckbox, {
  UnderwriterCheckboxProps,
} from '~/common/components/UnderwriterCheckbox/UnderwriterCheckbox';

const StyledBox = styled<any>(Box)((props) => ({
  opacity: props.isWriteAccessDisabled ? 0.6 : 1,
}));

const StyledText = styled<any>(Text)((props) => ({
  fontWeight: 500,
  marginBottom: '24px',
  ...props?.customStyles,
}));

type ContentProps = React.ComponentProps<typeof Box> & {
  children?: any;
  subHeading?: string;
  subHeadingStyles?: any;
  isWriteAccessDisabled?: boolean;
  disableBackground?: boolean;
  underwriterCheckbox?: UnderwriterCheckboxProps;
};

const Content = ({
  subHeading,
  subHeadingStyles,
  children,
  isWriteAccessDisabled,
  underwriterCheckbox,
  ...props
}: Readonly<ContentProps>) => {
  return (
    <Box {...props}>
      {subHeading && (
        <StyledText customStyles={subHeadingStyles}>{subHeading}</StyledText>
      )}
      <StyledBox
        onClick={(e) => {
          if (isWriteAccessDisabled) {
            e.preventDefault();
            e.stopPropagation();
          }
        }}
        isWriteAccessDisabled={isWriteAccessDisabled}
      >
        {children}
      </StyledBox>
      <UnderwriterCheckbox {...underwriterCheckbox} />
    </Box>
  );
};

export default Content;
